import React from 'react';
import { motion } from 'framer-motion';
import { DjayAvatar } from '../../mascot';
import type { DjayEmotion, DjayVariant } from '../../mascot';
interface MiniDjayPromptProps {
  message: string;
  emotion?: DjayEmotion;
  variant?: DjayVariant;
  position?: 'left' | 'right';
  className?: string;
}
export function MiniDjayPrompt({
  message,
  emotion = 'happy',
  variant = 'default',
  position = 'left',
  className = ''
}: MiniDjayPromptProps) {
  return <div className={`flex items-end gap-3 ${position === 'right' ? 'flex-row-reverse' : 'flex-row'} ${className}`} data-id="element-2220">
      <motion.div animate={{
      y: [0, -4, 0]
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="flex-shrink-0" data-id="element-2221">
        <DjayAvatar size="sm" emotion={emotion} variant={variant} animate data-id="element-2222" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9,
      x: position === 'left' ? -10 : 10
    }} animate={{
      opacity: 1,
      scale: 1,
      x: 0
    }} transition={{
      type: 'spring',
      bounce: 0.5
    }} className="relative" data-id="element-2223">
        <div className="bg-white px-4 py-2 rounded-2xl shadow-sm border-2 border-slate-100 text-sm font-bold text-slate-700 max-w-[200px]" data-id="element-2224">
          {message}
        </div>
        {/* Speech bubble tail */}
        <div className={`absolute bottom-2 w-3 h-3 bg-white border-b-2 border-slate-100 transform rotate-45
            ${position === 'left' ? '-left-1.5 border-l-2' : '-right-1.5 border-r-2'}`} data-id="element-2225" />
      </motion.div>
    </div>;
}